import React from 'react';
import PropTypes from 'prop-types';

const CalibratedProduct = props => (
  <div className="calibrated-product" key={props.id}>
    <div>
      <div className="calibrated-product-logo">{props.productLogoText}</div>
      <div className="calibrated-product-icon">
        <i className="RSLL-icon icon icon-rs_134-brand-calibration" />
      </div>
    </div>
    <div className="calibrated-product-detail">
      <p className="calibrated-product-description">
        <span className="calibrated-product-number-label">{props.labels.rsStockNo}</span>
        <span className="calibrated-product-number">{props.productId}</span>
      </p>
    </div>
    <div className="calibrated-product-button-container">
      <a className="calibrated-product-view-button" href={`/web${props.productLinkUrl}`}>{props.labels.view}</a>
    </div>
  </div>
);

CalibratedProduct.propTypes = {
  id: PropTypes.number,
  productId: PropTypes.number,
  productLogoText: PropTypes.string,
  productLinkUrl: PropTypes.string,
  labels: PropTypes.shape({
    rsStockNo: PropTypes.string,
    view: PropTypes.string,
  }),
};

CalibratedProduct.defaultProps = {
  id: 0,
  productId: 0,
  productLogoText: '',
  productLinkUrl: '',
  labels: {},
};

export default CalibratedProduct;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/CalibratedProduct/CalibratedProduct.js